require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#0808e0',
        accent: '#050548',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      dark: {
        primary: '#2b29fa',
        accent: '#3d3d79',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
